var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"nav-header"},[_c('NavHeader')],1),_c('div',{staticClass:"main-content",class:_vm.$mq},[_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view',{staticClass:"main-page"}):_vm._e()],1),(!_vm.$route.meta.keepAlive)?_c('router-view',{staticClass:"main-page"}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }